/**
 * Feature Endpoints
 */

export const apiPostFeature = async (
  feature: FeatureCreateUpdate,
): Promise<AxiosResponse<Feature>> => {
  return await userManagementAxiosInstance.post('features', feature);
};

export const apiGetFeatures = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
  search: string = '',
): Promise<AxiosResponse<PaginatedFeature>> => {
  return await userManagementAxiosInstance.get(
    `features?limit=${limit}&offset=${offset}&name=${search}`,
  );
};

export const apiGetFeature = async (id: string | number): Promise<AxiosResponse<Feature>> => {
  return await userManagementAxiosInstance.get(`features/${id}`);
};

export const apiPutFeature = async (
  feature: FeatureCreateUpdate,
): Promise<AxiosResponse<Feature>> => {
  return await userManagementAxiosInstance.put(`features/${feature.id}`, feature);
};

export const apiDeleteFeature = async (id: string | number): Promise<AxiosResponse<Feature>> => {
  return await userManagementAxiosInstance.delete(`features/${id}`);
};
